import {
  addToShoppingCart,
  getToShoppingCart,
  clsToShoppingCart,
} from '@/api/cart'

import {
  clearCart
} from '@/api/api'

const state = {
  show: false,
  qty: 0,
  subtotal: 0,
  goodslist: [],
  chooseList: {},
  productQty: {},
  attrRadio: {},
  products: [],
  radioGoodsAddons: '',
  x_sso_token: '',
  storeInfo:{},
}
const mutations = {
  SET_SHOW: (state, show) => {
    state.show = show
  },
  SET_QTY: (state, qty) => {
    state.qty = parseInt(qty)
  },
  SET_SUBTOTAL: (state, subtotal) => {
    state.subtotal = parseFloat(subtotal).toFixed(2)
  },
  SET_GOODSLIST: (state, goodslist) => {
    state.goodslist = goodslist || []
  },
  SET_CHOOSELIST: (state, chooseList) => {
    state.chooseList = chooseList || {}
  },
  SET_PRODUCTQTY: (state, productQty) => {
    state.productQty = productQty || {}
  },
  SET_PRODUCTS: (state, productsArray) => {
    state.products = productsArray || []
  },
  SET_ATTRRADIO: (state, attrRadio) => {
    state.attrRadio = attrRadio || {}
  },
  SET_RADIOGOODSADDONS: (state, radioAddons) => {
    state.radioGoodsAddons = radioAddons
  },
  SET_X_SSO_TOKEN: (state, x_sso_token) => {
    state.x_sso_token = x_sso_token
  },
  SET_STOREINFO: (state, storeInfo) => {
    state.storeInfo = storeInfo
  }
}

const actions = {
  showShoppingCart({
    commit
  }, boolean_val) {
    commit('SET_SHOW', boolean_val)
  },
  closeShoppingCart({
    commit
  }) {
    commit('SET_SHOW', false)
  },
  addToCart({
    commit
  }, queryParams) {
    return new Promise((resolve, reject) => {
      addToShoppingCart(queryParams).then(response => {
        const {
          data
        } = response
        if (!data.code) {
          reject('添加到购物车失败')
        }
        commit('SET_QTY', data.qty)
        commit('SET_SUBTOTAL', data.subtotal)
        commit('SET_GOODSLIST', data.goodslist)
        resolve()
      }).catch(error => {
        console.log('[addToCart.error]--------------', error)
        reject(error)
      })
    })
  },

  getShoppingCart({
    commit,
    state
  }, queryParams) {
    return new Promise((resolve, reject) => {
      getToShoppingCart(queryParams).then(response => {
        const {
          data
        } = response
        if (!data.code) {
          reject('获取购物车内容失败')
        }
        commit('SET_QTY', data.qty)
        commit('SET_SUBTOTAL', data.subtotal)
        commit('SET_GOODSLIST', data.goodslist)
        resolve(data)
      }).catch(error => {
        console.log('[getShoppingCart.error]--------------', error)
        reject(error)
      })
    })
  },
  settingRadioGoodsAddons({
    commit
  }, radioAddons) {
    commit('SET_RADIOGOODSADDONS', radioAddons)
  },
  settingQty({
    commit
  }, qty) {
    commit('SET_QTY', parseInt(qty))
  },
  settingSubtotal({
    commit
  }, subtotal) {
    commit('SET_SUBTOTAL', parseFloat(subtotal).toFixed(2))
  },
  settingGoodsList({
    commit
  }, goodsList) {
    commit('SET_GOODSLIST', goodsList)
  },
  settingChooseList({
    commit
  }, chooseList) {
    commit('SET_CHOOSELIST', chooseList)
  },
  settingProductQty({
    commit
  }, itemQtyList) {
    commit('SET_PRODUCTQTY', itemQtyList)
  },

settingXssoToken({
  commit
}, x_sso_token) {
  commit('SET_X_SSO_TOKEN', x_sso_token)
},

settingStoreInfo({
  commit
}, storeInfo) {
  commit('SET_STOREINFO', storeInfo)
},

  setAttrRadio({
    commit
  }, attrRadio) {
    let attr = {}
    if (attrRadio && attrRadio.attr_list != false) {
      console.log('------>[VUEX设置当前item的所有的规格列表和已选中的规格列表]');
      attrRadio.attr_list && attrRadio.attr_list.length && attrRadio.attr_list.forEach((item, index) => {
        attr['item' + index] = ''
        item.items && item.items.forEach((itm, idx) => {
          if (attrRadio.choosed && itm.id == attrRadio.choosed.optionid) {
            attr['item' + index] = idx
          }
        })
      })
    }
    commit('SET_ATTRRADIO', attr)
  },

  cleanShoppingCart({
    commit
  }, queryParams) {
    return new Promise((resolve, reject) => {
      clearCart('/app/index.php', queryParams).then(res => {
        const {
          data
        } = res
        if (!res.code) {
          reject(res.message)
        }
        commit('SET_QTY', 0)
        commit('SET_SUBTOTAL', 0)
        commit('SET_GOODSLIST', [])
        commit('SET_CHOOSELIST', {})
        resolve(data)
      }).catch((error) => {
        console.log('清空购物车====>error', error)
        reject(error)
      })

    })
  },
  resetShoppingCart({
    commit
  }, apiData) {
    const {
      totalprice,
      totalcount,
      cart
    } = apiData

    const goodsList = () => {
      const arrList = cart && cart.map(cartItem => {
        let arrItem = {
          cart_id: cartItem.id,
          goods_id: cartItem.goodsid,
          goods_name: cartItem.goodstitle,
          goodstitle: cartItem.goodstitle,
          sku: cartItem.sku,
          price: cartItem.price,
          qty: cartItem.total,
          optionid: cartItem.optionid,
          optionname: cartItem.optionname,
          optionlabel: cartItem.start,
          storeid: cartItem.storeid,
          weid: cartItem.weid,
          dinein_icon_color: cartItem.dinein_icon_color || false
        }
        return arrItem
      }, [])

      arrList && arrList.forEach((item, index) => {
        let strKey = item.sku + '-' + index + '-' + item.goods_id
        arrList[index]["str_key"] = strKey
      })
      return arrList
    }

    const chooseList = () => {
      let arr2List = {}
      cart && cart.forEach(cartItem => {
        if (!arr2List[cartItem.sku]) {
          arr2List[cartItem.sku] = []
        }
        if (parseInt(cartItem.total) > 0) {
          if (cartItem.optionid == '') {
            arr2List[cartItem.sku].push(cartItem.total + 'x ' + cartItem.optionname + ' (+RM ' + parseFloat(  cartItem.price * parseInt(cartItem.total) ).toFixed(2) + ')')
          } else {
            arr2List[cartItem.sku].push(cartItem.total + 'x ' + cartItem.optionname + ' (+RM ' + parseFloat( cartItem.price ).toFixed(2) + ')')
          }
        }
      });
      return arr2List
    }


    const goods = goodsList()
    const choosed = chooseList()

    const getQtyList = () => {
      //专门为购物车中的加减器设置的内容
      let arrQty = {}
      goods && goods.forEach(item => {
        arrQty[item.str_key] = item.qty
      })
      return arrQty
    }
    commit('SET_QTY', totalcount)
    commit('SET_SUBTOTAL', totalprice)
    commit('SET_GOODSLIST', goods)
    commit('SET_CHOOSELIST', choosed)
    if (apiData.products) {
      commit('SET_PRODUCTS', apiData.products)
    }
    commit('SET_PRODUCTQTY', getQtyList())
  }
}

export default {
  namespaced: true,
  mutations,
  state,
  actions
}